import type { Signal } from '@angular/core';

export interface EntityEditConfig {
  resourceName: string;
  /**
   * Base path for the entity edit page, e.g. '/persons'.
   * After a successful create, the router navigates to `[routePath, newId, ...editRouteSegments]`.
   */
  routePath: string;
  /**
   * Optional path to navigate to after delete or on cancel/back.
   * Defaults to `routePath` when not set.
   * Use when the edit page lives under a different prefix than the list page
   * (e.g. edit = '/calendars-list/:id', list = '/calendars').
   */
  listRoutePath?: string;
  i18nPrefix: string;
  defaultIcon: string;
  supportsAppearance?: boolean;
  supportsAuditLog?: boolean;
  supportsDelete?: boolean;
  editRouteSegments?: string[];
}

export interface EntityMutationResource<T> {
  value: Signal<T | null>;
  isLoading: Signal<boolean>;
  error: Signal<Error | undefined>;
  isComplete: Signal<boolean>;
  isSuccess: Signal<boolean>;
}

export interface EntityItemResource<T> {
  value: Signal<T | null>;
  isLoading: Signal<boolean>;
  error: Signal<Error | undefined>;
  isLoaded: Signal<boolean>;
}

export interface EntityCrudStrategy<TEntity, TPayload> {
  load(idSignal: Signal<string | null>): EntityItemResource<TEntity>;
  create(payload: TPayload): EntityMutationResource<TEntity>;
  update(id: string, payload: TPayload): EntityMutationResource<TEntity>;
  delete(id: string): EntityMutationResource<void>;
}
